import { useManagerMissing } from '../../dataHooks/timelineAndRemindersSectionHooks';
import { ValidationTable } from './ValidationTable';

const ManagerMissingValidation = () => {
  const { data: rowData, isLoading } = useManagerMissing();

  return (
    <ValidationTable
      rowData={rowData}
      isLoading={isLoading}
      title="Manager Missing"
      subTitle="Employees without managers won't receive a final reviewer if the manager is set as the final reviewer. You can download their list and update their managers in the employee roster or through the HRIS sync."
    />
  );
};

export { ManagerMissingValidation };
